import { Construction } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'

interface ComingSoonProps {
  featureName: string
  description?: string
  availableOn?: string
}

export function ComingSoon({ featureName, description, availableOn }: ComingSoonProps) {
  const navigate = useNavigate()
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <div className="max-w-sm text-center space-y-4">
        <div className="w-12 h-12 rounded-xl bg-soft-panel flex items-center justify-center mx-auto">
          <Construction size={22} className="text-slate-400" />
        </div>
        <div className="space-y-1.5">
          <p className="text-base font-medium text-deep-ink">{featureName} is in development</p>
          <p className="text-sm text-slate-500">
            {description ?? `${featureName} is being built and will be available soon.`}
          </p>
          {availableOn && (
            <p className="text-xs text-slate-400">Available on: {availableOn}</p>
          )}
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate(-1)}>
          ← Go back
        </Button>
      </div>
    </div>
  )
}
